function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import oaDialog from '@/components/form-common/dialog-form';
import oaFromBox from '@/components/common/oaFromBox';
import { roterPre } from '@/settings';
import { getcrudCateListApi, databaseListApi, dataEventGuanListApi, dataEventActionApi, dataEventTypeApi, dataEventSaveApi, dataEventDelApi, dataEventStatusApi } from '@/api/develop';
export default {
  name: 'FinanceList',
  components: {
    oaDialog: oaDialog,
    oaFromBox: oaFromBox
  },
  data: function data() {
    return {
      search: [{
        field_name: '关键字',
        field_name_en: 'name',
        form_value: 'input'
      }, {
        field_name: '关联实体',
        field_name_en: 'crud_id',
        form_value: 'select',
        data_dict: []
      }, {
        field_name: '关联应用',
        field_name_en: 'cate_id',
        form_value: 'select',
        data_dict: []
      }],
      tableData: [],
      loading: false,
      ids: [],
      fromData: {
        width: '600px',
        title: '新建触发器',
        btnText: '确定',
        labelWidth: '100px',
        type: ''
      },
      formConfig: [{
        type: 'select',
        label: '应用实体：',
        placeholder: '请选择应用实体',
        key: 'crud_id',
        options: []
      }, {
        type: 'select',
        label: '触发类型：',
        placeholder: '请选择触发类型',
        key: 'event',
        options: []
      }, {
        type: 'input',
        label: '触发器名称：',
        placeholder: '请输入触发器名称',
        key: 'name'
      }],
      formRules: {
        crud_id: [{
          required: true,
          message: '请选择应用实体',
          trigger: 'change'
        }],
        event: [{
          required: true,
          message: '请选择触发类型',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入触发器名称',
          trigger: 'blur'
        }]
      },
      actionList: [],
      formDataInit: {
        crud_id: '',
        event: '',
        name: ''
      },
      where: {
        name: '',
        crud_id: '',
        cate_id: '',
        id_order_dy: 1,
        limit: 15,
        page: 1
      },
      entityOptions: [],
      // 实体数据
      application: [],
      // 应用数据
      total: 0,
      options: [{
        label: '启用',
        value: 1
      }, {
        label: '停用',
        value: 0
      }]
    };
  },
  created: function created() {
    this.getList();
    this.getCrudAllType();
    this.getEntity();
    this.getOptions();
    this.getActionList();
  },
  methods: {
    // 获取应用分类
    getCrudAllType: function getCrudAllType() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getcrudCateListApi();
            case 2:
              data = _context.sent;
              _this.application = data.data.list;
              _this.search[2].data_dict = _this.application;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取实体数据
    getEntity: function getEntity() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var where, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              where = {
                cate_id: ''
              };
              _context2.next = 3;
              return databaseListApi(where);
            case 3:
              data = _context2.sent;
              _this2.entityOptions = data.data.list;
              _this2.formConfig[0].options = _this2.entityOptions;
              _this2.entityOptions.forEach(function (item) {
                item['name'] = item.table_name;
              });
              _this2.search[1].data_dict = _this2.entityOptions;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.where = {
          name: '',
          crud_id: '',
          cate_id: '',
          id_order_dy: 1,
          limit: 15,
          page: 1
        };
      } else {
        this.where = _objectSpread(_objectSpread({}, this.where), data);
      }
      this.getList();
    },
    // 获取触发器类型
    getOptions: function getOptions() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dataEventTypeApi(_this3.crud_id);
            case 2:
              data = _context3.sent;
              _this3.formConfig[1].options = data.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 修改状态
    handleStatus: function handleStatus(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dataEventStatusApi(row.id, {
                status: row.status
              });
            case 2:
              _this4.getList();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getEvent: function getEvent(val) {
      var index = this.formConfig[1].options.findIndex(function (item) {
        return item.value === val;
      });
      return this.formConfig[1].options[index] ? this.formConfig[1].options[index].label : '--';
    },
    getString: function getString(arr) {
      return arr.join('、');
    },
    // 根据id获取触发动作
    getAction: function getAction(val) {
      var textArr = [];
      this.actionList.map(function (item) {
        val.map(function (key) {
          if (item.value == key) {
            textArr.push(item.label);
          }
        });
      });
      return textArr.join('/');
    },
    // 获取执行动作类型
    getActionList: function getActionList() {
      var _this5 = this;
      dataEventActionApi().then(function (res) {
        _this5.actionList = res.data;
      });
    },
    // 新建触发器
    submit: function submit(data) {
      var _this6 = this;
      dataEventSaveApi(data).then(function (res) {
        _this6.getList();
        _this6.$refs.oaDialog.handleClose();
      });
    },
    // 新增
    addFinance: function addFinance() {
      this.$refs.oaDialog.openBox();
    },
    // 编辑
    editFn: function editFn(row) {
      var _this$$router$resolve = this.$router.resolve({
          path: "".concat(roterPre, "/event"),
          query: {
            crud_id: row.crud_id,
            id: row.id
          }
        }),
        href = _this$$router$resolve.href;
      window.open(href, '_blank');
    },
    // 删除触发器
    deleteFn: function deleteFn(row) {
      var _this7 = this;
      this.$modalSure('您确定要删除此触发器数据吗').then(function () {
        dataEventDelApi(row.id).then(function (res) {
          var totalPage = Math.ceil((_this7.total - 1) / _this7.where.limit);
          var currentPage = _this7.where.page > totalPage ? totalPage : _this7.where.page;
          _this7.where.page = currentPage < 1 ? 1 : currentPage;
          _this7.getList();
        });
      });
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getList();
    },
    // 获取触发器列表
    getList: function getList() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this8.loading = true;
              _context5.next = 3;
              return dataEventGuanListApi(_this8.where);
            case 3:
              data = _context5.sent;
              _this8.total = data.data.count;
              _this8.tableData = data.data.list;
              _this8.loading = false;
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    restData: function restData() {
      this.where.page = 1;
      this.where.name = '';
      this.where.cate_id = '';
      this.where.crud_id = '';
      this.getList();
    }
  }
};